import * as actions from '@store/_actions'
import * as mutations from '@store/_mutations'
import repo from '../repository/repo'

export default {
    [actions.SET_CURRENT_PROFILE]({ commit }, profile) {
        commit(mutations.SET_CURRENT_PROFILE, profile)

        const menuItems = profile.menu_items.slice(0)
        const menu = _.uniqBy(
            menuItems.map((item) => item.menu),
            (menu) => menu.id
        ).map((menu) => ({ ...menu, menuItems: menuItems.filter((x) => x.menu_id === menu.id) }))

        commit(mutations.SET_MENU, menu)
    },
    async [actions.VERIFY_PERSON]({ commit, dispatch }, { payload, token }) {
        console.log('in actions verify person', token)
        try {
            const { data } = await repo.post(`/auth/nova/verify`, { payload }, { headers: { 'X-Magic-Token': token } })
            const { user, person, venue, capabilities, roles, profile, client } = data

            console.log('VERIFY_PERSON', data)
            const caps = _.values(capabilities)
            commit(mutations.SET_CURRENT_USER, user)
            commit(mutations.SET_CURRENT_PERSON, person)
            commit(mutations.SET_CURRENT_VENUE, venue)
            commit(mutations.SET_CAPABILITIES, caps)
            commit(mutations.SET_PERSON_ROLES, roles)
            commit(mutations.SET_CURRENT_PROFILE, profile)
            commit(mutations.SET_MENU, constructMenu(profile.menu_items))
            commit(mutations.SET_CURRENT_CLIENT, client)
        } catch (error) {
            console.error(error)
        }
    },
    // chat
    async [actions.AGENT_LOGIN]({ commit, rootGetters }) {
        try {
            const userId = rootGetters.currentUser.id
            const { data } = await repo.get(`users/${userId}/agent`)
            const { error, agent } = data
            if (error) return toastr.error(error)

            commit(mutations.SET_AGENT, agent)
            return agent
        } catch (error) {
            toastr.error(`Ocurrió un error al intentar iniciar sesión como agente: ${error.message}`)
        } finally {
            commit(mutations.SET_LOGING_IN_PROGRESS, false)
        }
    },
    async [actions.LOAD_AGENT_CONVERSATIONS]({ commit, getters }) {
        if (!getters.agent) return

        const { data } = await repo.get(`agents/${getters.agent.id}/conversations`)

        const { conversations } = data

        commit(mutations.SET_CONVERSATIONS, conversations)

        return conversations
    },
    async [actions.LOAD_CONVERSATIONS]({ commit, getters }) {
        try {
            const client = getters.currentClient
            const { data: agentData } = await repo.get(`clients/${client.id}/agents`)
            const agentIds = agentData.agents.map((agent) => agent.id)
            const conversations = []

            for (const agentId of agentIds) {
                const { data } = await repo.get(`agents/${agentId}/conversations`)
                if (data.conversations) {
                    conversations.push(...data.conversations)
                }
            }
            // Puedes usar lodash para ordenar las conversaciones por fecha o cualquier otro criterio
            const sortedConversations = _.orderBy(conversations, ['created_at'], ['desc'])
            commit(mutations.SET_CONVERSATIONS, sortedConversations)
            return sortedConversations
        } catch (error) {
            toastr.error(`Ocurrió un error al cargar las conversaciones: ${error.message}`)
        }
    },
    // async [actions.LOAD_HISTORY_CONVERSATIONS]({ commit, getters }) {
    //     try {
    //         const client = getters.currentClient
    //         const conversations = []
    //         const { data } = await repo.get(`clients/${client.id}/history-conversations`)
    //             if (data.conversations) {
    //                 conversations.push(...data.conversations)
    //             }

    //         // Puedes usar lodash para ordenar las conversaciones por fecha o cualquier otro criterio
    //         const sortedConversations = _.orderBy(conversations, ['created_at'], ['desc'])
    //         commit(mutations.SET_HISTORY_CONVERSATIONS, sortedConversations)
    //         return sortedConversations
    //     } catch (error) {
    //         toastr.error(`Ocurrió un error al cargar el historial de las conversaciones: ${error.message}`)
    //     }
    // },
    async [actions.LOAD_MESSAGES]({ commit }, from) {
        const { data } = await repo.get(`chat/messages`, {
            from,
            hasAgent: 1,
            sortBy: 'created_at',
            sortDir: 'desc',
        })

        const { error, messages } = data

        if (error) return toastr.error(error)

        commit(mutations.SET_MESSAGES, messages)
    },
    // async [actions.LOAD_HISTORY_MESSAGES]({ commit }, from) {
    //     const { data } = await repo.get(`chat/messages`, {
    //         from,
    //         hasAgent: 1,
    //         sortBy: 'created_at',
    //         sortDir: 'desc',
    //     })

    //     const { error, messages } = data

    //     if (error) return toastr.error(error)

    //     commit(mutations.SET_HISTORY_MESSAGES, messages)
    // },
    async [actions.CONNECT_AGENT]({ commit, getters }) {
        const { data } = await repo.post(`agents/${getters.agent.id}/connect`)

        const { error, connection } = data

        if (error) return toastr.error(error)

        commit(mutations.SET_AGENT_CONNECTION, connection)
    },
    async [actions.DISCONNECT_AGENT]({ commit, getters }) {
        const { data } = await repo.post(`agents/${getters.agent.id}/disconnect`)

        const { error, connection } = data

        if (error) return toastr.error(error)

        commit(mutations.SET_AGENT_CONNECTION, null)
    },
    async [actions.LOAD_AGENT_CONNECTION]({ commit, getters }) {
        const { data } = await repo.get(`agents/${getters.agent.id}/connection`)

        const { error, connection } = data

        if (error) return toastr.error(error)

        commit(mutations.SET_AGENT_CONNECTION, connection)
    },
    async [actions.LOAD_PERSON_CAPABILITIES]({ commit, state }, personId) {
        const { data } = await repo.get(`people/${personId}/capabilities`, { profileId: state.currentProfile?.id ?? null })

        const allCapabilities = Array.from(new Set([...state.capabilities, ...Object.values(data)]))

        commit(mutations.SET_CAPABILITIES, allCapabilities)
    },
}
const constructMenu = (menuItems) => {
    const menu = _.uniqBy(
        menuItems.map((item) => item.menu),
        (menu) => menu.id
    ).map((menu) => ({ ...menu, menuItems: menuItems.filter((x) => x.menu_id === menu.id) }))
    return menu
}
